<template>
  <div>
    <div class="page-head">
      <div>
        <h2>资金流水</h2>
        <p>所有流水由确认或冲销动作自动产生，不能直接编辑</p>
      </div>
      <el-button
        :loading="loading"
        @click="load"
      >
        刷新
      </el-button>
    </div>
    <el-card shadow="never">
      <div class="filters">
        <el-select
          v-model="accountId"
          clearable
          placeholder="全部账户"
          @change="reload"
        >
          <el-option
            v-for="item in accounts"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          />
        </el-select>
      </div>
      <el-table
        v-loading="loading"
        :data="rows"
        stripe
      >
        <el-table-column
          prop="flow_date"
          label="发生时间"
          width="170"
        />
        <el-table-column
          prop="account_name"
          label="资金账户"
          width="130"
        />
        <el-table-column
          label="方向"
          width="90"
        >
          <template #default="{ row }">
            <el-tag :type="row.direction === 'IN' ? 'success' : 'danger'">
              {{ row.direction === 'IN' ? '流入' : '流出' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="金额"
          width="140"
        >
          <template #default="{ row }">¥ {{ money(row.amount) }}</template>
        </el-table-column>
        <el-table-column
          prop="biz_type"
          label="业务类型"
          width="150"
        />
        <el-table-column
          prop="biz_id"
          label="业务编号"
          width="100"
        />
        <el-table-column
          prop="reversal_of"
          label="冲销原流水"
          width="110"
        />
        <el-table-column
          prop="note"
          label="说明"
          min-width="180"
        />
      </el-table>
      <div class="pager">
        <el-pagination
          v-model:current-page="page"
          v-model:page-size="pageSize"
          layout="total, prev, pager, next"
          :total="total"
          @current-change="load"
        />
      </div>
    </el-card>
  </div>
</template>
<script setup>
import { onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { ledgerApi } from '../api'

const rows = ref([])
const accounts = ref([])
const loading = ref(false)
const accountId = ref(null)
const page = ref(1)
const pageSize = ref(20)
const total = ref(0)
const money = (value) =>
  Number(value || 0).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
const load = async () => {
  loading.value = true
  try {
    const data = await ledgerApi.accountFlows({
      page: page.value,
      pageSize: pageSize.value,
      accountId: accountId.value,
    })
    rows.value = data.items || []
    total.value = data.total || 0
  } catch (error) {
    ElMessage.error(error?.message || '流水加载失败')
  } finally {
    loading.value = false
  }
}
const reload = () => {
  page.value = 1
  load()
}
onMounted(async () => {
  accounts.value = await ledgerApi.accounts().catch(() => [])
  load()
})
</script>
<style scoped>
.page-head {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}
.page-head h2 {
  font-size: 24px;
}
.page-head p {
  color: #8a97a8;
  margin-top: 6px;
}
.el-card {
  border: 0;
}
.filters {
  margin-bottom: 16px;
}
.pager {
  display: flex;
  justify-content: flex-end;
  margin-top: 18px;
}
</style>
